import React from 'react';
import { Link } from 'react-router-dom';
import { SignupForm } from '../components/SignupForm';

export const Signup: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-primary-50">
      {/* Header */}
      <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-lg border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <img
                src="/branding/competepages-logo.png"
                alt="CompetePages"
                className="h-10 w-auto object-contain"
              />
            </Link>
            <div className="flex items-center space-x-4">
              <Link to="/login" className="btn-ghost">
                Sign In
              </Link>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 min-h-[calc(100vh-80px)]">
        <SignupForm />
      </main>
    </div>
  );
};
